import { useCallback } from 'react';
import { SplitClient, SplitTreatments } from '@splitsoftware/splitio-react';
import { addSplitImpression } from '../services/Backend/account';
import { useAccount } from '../contexts/Account';

function Treatment(props) {
  const {
    splitNames,
    evaluatedComponent,
    conditionFailedComponent,
    customId = null,
  } = props;

  const { currentUserInfo } = useAccount();
  const userId =
    currentUserInfo && currentUserInfo.username
      ? currentUserInfo.username
      : 'not_id';

  const addImpressionCall = useCallback(async (treatment) => {
    await addSplitImpression({
      SPLIT: splitNames,
      TREATMENT: treatment,
      USER_ID: userId,
    });
  }, []);

  return (
    <SplitClient splitKey={customId || userId} updateOnSdkTimedout>
      <SplitTreatments names={[splitNames]}>
        {({ treatments, isReady, isTimedout }) => {
          let result;
          if (
            (isReady && treatments[splitNames].treatment === 'on') ||
            isTimedout
          ) {
            result = evaluatedComponent;
          } else if (isTimedout) {
            result = <div>SDK timed out (check your API key)</div>;
          } else if (!isReady) {
            result = <div>Loading SDK...</div>;
          } else {
            result = conditionFailedComponent ? conditionFailedComponent : null;
          }
          addImpressionCall(treatments[splitNames].treatment);
          return result;
        }}
      </SplitTreatments>
    </SplitClient>
  );
}

export default Treatment;
